import { render, staticRenderFns } from "./HistorySms.vue?vue&type=template&id=34b63b78&scoped=true"
import script from "./HistorySms.vue?vue&type=script&lang=js"
export * from "./HistorySms.vue?vue&type=script&lang=js"
import style0 from "./HistorySms.vue?vue&type=style&index=0&id=34b63b78&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b63b78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34b63b78')) {
      api.createRecord('34b63b78', component.options)
    } else {
      api.reload('34b63b78', component.options)
    }
    module.hot.accept("./HistorySms.vue?vue&type=template&id=34b63b78&scoped=true", function () {
      api.rerender('34b63b78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/notify/HistorySms.vue"
export default component.exports